/**
 * @generated SignedSource<<56d7c0d816ec68098611836cc08f2554>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShallowAnswer_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerString_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerText_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerRichText_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerFile_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerCheckBoxes_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerBudgetDispatcher_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerThemes_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerEvents_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerEmailWithConsents_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerOralInterview_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerSortableList_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerMatrix_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPresentationTitle_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPresentationTextZone_answer"
    }
  ],
  "type": "AnswerBase",
  "abstractKey": "__isAnswerBase"
};

node.hash = "0e5bfa81a7f84f95037178f2a3f7f352";

module.exports = node;
